// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { isEmptyString } from "@eisinc/XDL/Utilities";

export const xRegex = {
    numbers: /[^0-9]/g,
    email: new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/),
    phone: /^([\(\)/\-\.\+\s]*\d\s?(ext)?[\(\)/\-\.\+\s]*){10,}$/,
    qty: /[^0-9]/g,
    decimal: /[^\d.]/g,
};

export const maxLengthAttr = {
    email: 128,
    userName: 50,
    password: 30,
    qty: 6,
    phone: 10,
    addToList: 50,
    note: 500,
    smallNote: 300,
    jobName: 100,
    quoteNotes: 500,
    subject: 50,
    search: 100,
    address: 50,
    city: 50,
    postalCode: 10,
};

export const xValidation = {
    email: (value: string, isRequired = false) => {
        if (isRequired && isEmptyString(value)) {
            return false;
        }
        if (!isRequired && isEmptyString(value)) {
            return true;
        }
        return xRegex.email.test(value) && value.length <= maxLengthAttr.email;
    },
    phone: (value: string, isRequired = false) => {
        if (isRequired && isEmptyString(value)) {
            return false;
        }
        if (!isRequired && isEmptyString(value)) {
            return true;
        }
        return xRegex.phone.test(value) && value.length <= maxLengthAttr.phone;
    },
    password: (value: string, isRequired = false) => {
        if (isRequired && isEmptyString(value)) {
            return false;
        }
        if (!isRequired && isEmptyString(value)) {
            return true;
        }
        return value.length <= maxLengthAttr.password;
    },
    userName: (value: string, isRequired = false) => {
        if (isRequired && isEmptyString(value)) {
            return false;
        }
        if (!isRequired && isEmptyString(value)) {
            return true;
        }
        return value.length <= maxLengthAttr.userName;
    },
    isDecimal: (value: string) => xRegex.decimal.test(value),
};
